
import * as cloudflareRuntime$_45GKDwe3hcRZhxIRcKq_mPcpM8ouQUa_459wqRD_45gbwmmk from '/home/runner/work/nuxt.com/nuxt.com/node_modules/.pnpm/@nuxt+image@https+++pkg.pr.new+@nuxt+image@1a5786c_db0@0.3.2_better-sqlite3@11.10.0__ioredis@5.6.1_magicast@0.3.5/node_modules/@nuxt/image/dist/runtime/providers/cloudflare'
import * as ipxRuntime$HuJvtFmyzd5VnogBIYLMzqNgo816kHBC99scVQdwsGM from '/home/runner/work/nuxt.com/nuxt.com/node_modules/.pnpm/@nuxt+image@https+++pkg.pr.new+@nuxt+image@1a5786c_db0@0.3.2_better-sqlite3@11.10.0__ioredis@5.6.1_magicast@0.3.5/node_modules/@nuxt/image/dist/runtime/providers/ipx'
import * as noneRuntime$dcuImedhb4DMWhvmLDbcLf377c5JyLAq2JONjCS0vGc from '/home/runner/work/nuxt.com/nuxt.com/node_modules/.pnpm/@nuxt+image@https+++pkg.pr.new+@nuxt+image@1a5786c_db0@0.3.2_better-sqlite3@11.10.0__ioredis@5.6.1_magicast@0.3.5/node_modules/@nuxt/image/dist/runtime/providers/none'

export const imageOptions = {
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1536
  },
  "presets": {},
  "provider": "cloudflare",
  "domains": [],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp",
    "jpeg",
    "jpg",
    "png",
    "svg",
    "webp"
  ]
}

imageOptions.providers = {
  ['cloudflare']: { provider: cloudflareRuntime$_45GKDwe3hcRZhxIRcKq_mPcpM8ouQUa_459wqRD_45gbwmmk, defaults: {"baseURL":"https://nuxt.com"} },
  ['ipx']: { provider: ipxRuntime$HuJvtFmyzd5VnogBIYLMzqNgo816kHBC99scVQdwsGM, defaults: {"baseURL":"https://ipx.nuxt.com"} },
  ['none']: { provider: noneRuntime$dcuImedhb4DMWhvmLDbcLf377c5JyLAq2JONjCS0vGc, defaults: {} }
}
        